import { h } from "preact";

function FacetecIcon({ size = 16 }) {
    return (
        <img
            src="https://play-lh.googleusercontent.com/-Hs79n-HveWnlLgpiKWc_vCqRrg3B7gB_0Wupt2UrJckz__hyAZwuBIyInkllRr1w1E=w240-h480"
            alt="Facetec"
            style={{ width: `${size}px`, height: `${size}px`, objectFit: "contain" }}
        />
    );
}

export default FacetecIcon;

